import { render, staticRenderFns } from "./OrdresPendents.vue?vue&type=template&id=81758b02"
import script from "./OrdresPendents.vue?vue&type=script&lang=js"
export * from "./OrdresPendents.vue?vue&type=script&lang=js"
import style0 from "./OrdresPendents.vue?vue&type=style&index=0&id=81758b02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports